import ProductDetailsTabs from "./DetailTabs";
import { ToastContainer } from "react-toastify";

const AddProductModal = ({ showModal, closeModal, filters, reloadPage }) => {
  return (
    <>
      <div
        className={`modal ${showModal ? "show" : "hide"}`}
        id="orderDetailModal"
      >
        <ToastContainer hideProgressBar={true} autoClose={2000} />
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content ">
            <div className="modal-header">
              <div className="d-flex justify-content-center align-items-center gap-2">
                <>
                  <h5 className="modal-title">Add New Product</h5>
                </>
              </div>
              <button type="button" className="close" onClick={closeModal}>
                &times;
              </button>
            </div>
            <ProductDetailsTabs
              filters={filters}
              reloadPage={reloadPage}
              closeModal={closeModal}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProductModal;
